import SEO from "../components/seo";
import LayoutTwo from "../layouts/LayoutTwo";
import CollectionGrid from "../components/Home/CollectionGrid";
import PostHero from "../components/Home/PostHero";
import HomeFeaturedProducts from "../wrappers/product/HomeFeaturedProducts";
import HomeHero from "../wrappers/hero/HomeHero";
import MostViewedProducts from "../wrappers/product/MostViewedProducts";
import "../assets/css/home.css";
import CategoryShow from "../components/Home/CategoryShow";
import CollectionShow from "../components/Home/CollectionShow";
import LoadingSpinner from "../components/loading/LoadingSpinner";
import { useEffect, useState } from "react";

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setInterval(() => {
      setIsLoading(false);
    }, 2000)
  }, []);

  return (
    <>
      <SEO titleTemplate="Home" />
      <LayoutTwo>
        {isLoading && <LoadingSpinner />}
        <div className="home_page">
          <CategoryShow />
          <CollectionShow />
          {/* <HomeHero /> */}
          {/* <PostHero /> */}
          {/* <CollectionGrid /> */}
          {/* <HomeFeaturedProducts /> */}
          {/* <MostViewedProducts /> */}
        </div>
      </LayoutTwo>
    </>
  );
};

export default Home;
